export default {
  last: 0,
  series: 1
};
